export default __webpack_public_path__ + "static/media/default-event-marker.afc0cb93.png";